<template>
  <div>
    <table class="table" v-show="!loading">
      <thead>
        <tr>
          <th style="width:32%">アカウント名</th>
          <th style="width:32%">メールアドレス</th>
          <th style="width:18%">区分</th>
          <!-- <th :style="{width: companyContactAuthority ? '150px': '210px', textTransform: 'none' }">人事 or 部門</th>
        <th :style="{width: companyContactAuthority ? '150px': '210px'}">ユーザー編集権限</th>
        <th style="width:150px;" v-if="companyContactAuthority">個別連絡利用権限</th> -->
          <th style="width: 18%">操作</th>
          <!-- <th style="width:100px;"></th> -->
        </tr>
      </thead>
      <tbody>
        <UserRow
          v-for="user in users"
          v-bind:key="user.id"
          :userData="user"
          :contactAuthority="companyContactAuthority"
        />
        <tr v-if="!users.length">
          <td colspan="100%" class="text-center">No users found.</td>
        </tr>
      </tbody>
    </table>
    <Loader v-show="loading" />
  </div>
</template>

<script>
import Loader from '@/components/utils/Loader.vue';
import UserRow from '@/components/users/UserRow.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UserList',
  components: { UserRow, Loader },
  data() {
    return {
      loading: false,
      page: 1,
      pagination: {},
    };
  },
  async mounted() {
    this.loading = true;
    if (!this.getCurrentUser) {
      await this.loadCurrentUser();
    }
    if (!this.isAdmin) {
      this.$router.push({ path: '/applicant' });
    }
    if (this.users && !this.users.length) {
      await this.loadUsers();
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      getCurrentUser: 'getCurrentUser',
      isAdmin: 'currentUserIsAdmin',
    }),
    companyContactAuthority() {
      return this.getCurrentUser && this.getCurrentUser.companyContactAuthority;
    },
  },
  methods: {
    ...mapActions({
      loadUsers: 'loadUsers',
      loadCurrentUser: 'loadCurrentUser',
    }),
  },
};
</script>
<style scoped>
table {
  width: 85%;
  position: relative;
  margin: auto; 
}

.table thead {
  border-bottom: 1px solid #787878 !important;
}

.table th {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
</style>
